import { AxiosRequestConfig } from "axios";
import { baseApiService } from "../../../shared/services/api/axios-config/axios-config";
import { errosHandler } from "../../../shared/services/errors/erros-handler";
import { toSlug } from "../../../shared/utils";
import { CriarObraFormData } from "../schema/criar-obra.schema";
import { EditarObraFormData } from "../schema/editar-obra.schema";


const criar = async (data: CriarObraFormData, config?: AxiosRequestConfig<any> | undefined): Promise<void> => {
    try {
        const response = await baseApiService.post('/work', data, config);
        return response.data.data.id;
    } catch (err) {
        throw errosHandler(err);
    }
};

const deletar = async (id: string): Promise<string> => {
    try {
        const response = await baseApiService.delete(`/work/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const detalhar = async (id: string): Promise<any> => {
    try {
        const response = await baseApiService.get(`/work/${id}`);
        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};

const editar = async (id: string, data: EditarObraFormData): Promise<void> => {
    try {
        await baseApiService.put(`/work/${id}`, data);
    }
    catch (err) {
        throw errosHandler(err);
    }
};

const findAll = async (filtro?: string, pagina = 0, limite = 10, campo?: string): Promise<{ items: any[]; totalItems: number }> => {
    try {
        const filtroPesquisa = filtro?.trim() ? toSlug(filtro) : "";
        const query = filtroPesquisa
            ? `/work?page=${pagina + 1}&limit=${limite}&campo_pesquisa=slug&tipo_pesquisa=in&valor_pesquisa=${filtroPesquisa}`
            : `/work?page=${pagina + 1}&limit=${limite}`;
        const result = await baseApiService.get(query);
        const responseData = result.data?.data;
        return {
            items: Array.isArray(responseData?.items) ? responseData.items : [],
            totalItems: responseData?.meta?.totalItems || 0,
        };
    } catch (error) {
        console.error("Erro ao buscar empresas:", error);
        throw errosHandler(error);
    }
};


const selectObra = async (): Promise<any> => {
    try {
        const response = await baseApiService.get("/work/select");

        return response.data.data;
    } catch (err) {
        throw errosHandler(err);
    }
};


export const obraService = {
    criar,
    deletar,
    detalhar,
    editar,
    findAll,
    selectObra
};

